import React, { useState } from "react";
import { COMPANY_DATA } from "../../constants/placeholder";
import logo from "../../assets/images/logo_blue_transparent.png";
import { Container } from "@mui/material";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle subscription logic here
    console.log("Subscribing email:", email);
  };

  return (
    <footer className="bg-gray-800 text-gray-300">
      <Container>
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* About Travel */}
            <div>
              <h3 className="text-white font-semibold mb-4">
                ABOUT {COMPANY_DATA.name}
              </h3>
              <p className="text-sm mb-4">{COMPANY_DATA.shortAbout}</p>
              {/* <div className="flex space-x-4">
                <img
                  src="/api/placeholder/60/60"
                  alt="Award Winner"
                  className="h-12"
                />
                <img
                  src="/api/placeholder/60/60"
                  alt="Nature Magazine"
                  className="h-12"
                />
              </div> */}
            </div>

            {/* Contact Information */}
            <div>
              <h3 className="text-white font-semibold mb-4">
                CONTACT INFORMATION
              </h3>
              <p className="text-sm mb-4">
                Contact us for any questions or inquiries.
              </p>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center space-x-2">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="#016E99"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  <span>{COMPANY_DATA.phones[0]}</span>
                </li>
                <li className="flex items-center space-x-2">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="#016E99"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <span>{COMPANY_DATA.emails[0]}</span>
                </li>
                <li className="flex items-center space-x-2">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="#016E99"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <span>{COMPANY_DATA.addresses[0].name}</span>
                </li>
              </ul>
            </div>

            {/* Subscribe Form */}
            <div>
              <h3 className="text-white font-semibold mb-4">SUBSCRIBE US</h3>
              <p className="text-sm mb-4">
                Subscribe to our monthly newletter to get the latest updates.
              </p>
              <form onSubmit={handleSubscribe}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your Email..."
                  className="w-full px-4 py-2 mb-3 bg-gray-700 text-white rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  type="submit"
                  className="w-full px-4 py-2 bg-primary text-white rounded-full shadow-xl hover:shadow-2xl transition-colors"
                >
                  SUBSCRIBE NOW
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700">
          <div className="max-w-7xl mx-auto px-4 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex items-center space-x-4">
                <a href="#" className="text-sm hover:text-white">
                  Privacy Policy
                </a>
                <span>|</span>
                <a href="#" className="text-sm hover:text-white">
                  Term & Condition
                </a>
                <span>|</span>
                <a href="#" className="text-sm hover:text-white">
                  FAQ
                </a>
              </div>
              <img src={logo} alt="Renpha Logo" className="h-14" />
              <p className="text-sm">
                Copyright © {new Date().getFullYear()} {COMPANY_DATA.name}. All
                rights reserveds
              </p>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
